<template>
  <transition name='fade'>
    <div
      class="modal remarks_opacity"
      v-if='visible'
      style="z-index:1000;"
    >
      <div class="remark">
        <div class="remark_title el-message-box__header msp_icon_close">
          <span>审核</span>
          <span
            class="iconfont el-icon-close"
            @click.stop='closeVisible()'
          ></span>
        </div>
        <div class="manuscript_input_title">
          请输入审核意见
        </div>
        <div class='remark_textarea_input'>
          <el-input
            type="textarea"
            placeholder="请输入内容"
            :maxlength="maxLength"
            show-word-limit
            class="mark_info_input"
            v-model="inputValue"
          >
          </el-input>
        </div>

        <div class="remark_bottom">
          <div class="remark_bottom_right">
            <el-button
              type="danger"
              v-if='!isLoading'
              @click.native='auditThroughOrNot("no")'
            >不通过</el-button>
            <el-button
              type="primary"
              v-if='!isLoading'
              @click.native='auditThroughOrNot("yes")'
            >通过</el-button>
            <el-button
              type="primary"
              v-if='!isLoading && (currentObjData.ctrl && currentObjData.ctrl.role_type !=="flow")'
              @click.native='auditThroughOrNot("doing")'
            >转送审</el-button>
            <el-button
              type="info"
              v-if='isLoading'
              disabled
            >正在提交请稍后</el-button>

          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'
import logsMixins from '../../../mixins/logs'
export default {
  name: 'auditarticle',
  data () {
    return {
      visible: false,
      maxLength: 200,
      inputValue: '',
      currentObjData: '',
      currentObjType: '',
      isLoading: false,
      turnToOtherId: ''

    }
  },
  mixins: [logsMixins],
  mounted () {
    this.$root.eventHub.$on('auditArticleModel', (data, type) => {
      this.visible = true
      this.currentObjData = data
      this.currentObjType = type

    })

    this.$root.eventHub.$on('turnToOtherUser', (data) => {
      this.turnToOtherId = data[0].id
      this.auditThroughOrNot('turnOther')
    })
  },
  destroyed () {
    this.$root.eventHub.$off('auditArticleModel')
    this.$root.eventHub.$off('turnToOtherUser')
  },
  components: {

  },
  methods: {
    closeVisible () {
      this.visible = false
    },

    auditThroughOrNot (status) {
      if (status === 'yes' || status === 'no' || status === 'turnOther') {
        this.isLoading = true
        var id_to_user = ''
        var auditStatus = ''
        var url = ''
        if (status === 'yes' || status === 'no') {
          id_to_user = ''
          auditStatus = status
        } else {
          id_to_user = this.turnToOtherId
          auditStatus = 'doing'
        }
        var option = {
          ...this.$store.getters.baseOption,
          "params": {                       // 必须字段： 参数
            "id": this.currentObjData.id,               // 必须字段：审核条目的 ID
            "audit_status": auditStatus,  // 必须字段：审核通过为  yes  审核不通过为  no   审核通过并指定下一个审核人为  doing 取消审核 cancel
            "id_to_user": id_to_user,  // 关联的可选（必须）字段：下一步审核人的 ID。当 audit_status 的值为 doing 时，此字段必须填。
            "comment": this.inputValue,            // 可选字段：审核的评论内容
            "content_type": "article",
          }
        }

        if (this.currentObjType === 'normalAudit') {
          if (this.currentObjData.doc_type === 'document') {
            url = _API_ + 'api/article/doc/audit/do_audit'
          } else {
            if (this.currentObjData.ctrl && this.currentObjData.ctrl.role_type === 'flow') {
              url = _API_ + 'api/article/audit/do_audit_flow'
              option = {
                ...this.$store.getters.baseOption,
                "params": {                       // 必须字段： 参数
                  "audit_id": this.currentObjData.id,               // 必须字段：审核条目的 ID
                  "audit_status": auditStatus,  // 必须字段：审核通过为  yes  审核不通过为  no   审核通过并指定下一个审核人为  doing 取消审核 cancel
                  "comment": this.inputValue           // 可选字段：审核的评论内容
                }
              }
            } else {
              url = _API_ + 'api/article/audit/do_audit'
            }

          }

        } else if (this.currentObjType === 'fastAudit') {
          if (this.currentObjData.doc_type === 'document') {
            url = _API_ + 'api/article/doc/audit/audit_one_key'
          } else {
            url = _API_ + 'api/article/audit/audit_one_key'
          }

        }

        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            if (this.$route.path === "/editorArticle" || this.$route.path === "/atlasmanuscript") {
              this.$set(this.currentObjData, 'audit_status', res.data.content.audit_status)
              eventButtonBus.$emit('getOperateArticleData', res.data.content)
              this.$root.eventHub.$emit('getAuditInfoByArticleIdModel', '')
              this.getAuditLogs(res.data.content.id)
              this.getOperateLogs(res.data.content.id)
              try {
                window.opener.postMessage(res.data.content, '*')
              } catch (error) {
                console.log(error)
              }
            } else {
              if (this.currentObjType === 'normalAudit') {
                this.$root.eventHub.$emit('previewArticleModel', res.data, 'preViewMyAuditContent')
                this.$root.eventHub.$emit('setMyauditAuditStatus', res.data)
              } else if (this.currentObjType === 'fastAudit') {
                this.$set(this.currentObjData, 'audit_status', res.data.content.audit_status)
                this.$root.eventHub.$emit('setSendAuditStatus', this.currentObjData, res.data.content.audit_status)
                this.getAuditLogs(this.currentObjData.id)
                this.getOperateLogs(this.currentObjData.id)
              }
            }
            this.visible = false
            this.isLoading = false
          } else {
            this.isLoading = false
          }
          this.$root.eventHub.$emit('getMyAuditDoingNum', '')
        }).catch((error) => {
          console.log(error)
          this.isLoading = false
        })
      } else if (status === 'doing') {
        this.$root.eventHub.$emit('sendAuditModel', [this.currentObjData], 'turnToOtherAudit')
      }

    }

  },
  watch: {
    visible () {
      if (!this.visible) {
        this.inputValue = ''
        this.currentObjData = ''

      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.remarks_opacity
  center()
  .remark
    box-sizing border-box
    width 520px
    height 360px
    border-radius 8px
    background #fff
    .remark_title
      title-name()
      clear both
      margin-bottom 10px
      line-height 48px
      .iconfont
        float right
        margin-right 20px
        line-height 48px
        cursor pointer
    .manuscript_input_title
      base-title()
      margin-bottom 10px
      padding-left 20px
    .remark_textarea_input
      box-sizing border-box
      padding-right 20px
      padding-left 20px
    .remark_bottom
      clear both
      box-sizing border-box
      padding-top 10px
      padding-right 20px
      .remark_bottom_right
        float right
        padding-top 12px
        button
          height 36px
          line-height 0px
</style>
